import { Box, Card } from '@mui/material';
import { TextPlaceholder } from '../../placeholders/text.placeholder';
import { useDeliveriesRequiringAttentionHoverCardStyles } from './deliveries-requiring-attention-hover-card.styles';

export type DeliveriesRequiringAttentionHoverCardProps = {
  isLoading?: boolean;
  heading: string;
  title?: string;
  message?: string;
  events?: {
    leftAlignedContent: string;
    rightAlignedContent: string;
  }[];
  error?: string;
};

export function DeliveriesRequiringAttentionHoverCard({
  heading,
  title,
  message,
  events,
  error,
  isLoading = false
}: DeliveriesRequiringAttentionHoverCardProps) {
  const classes = useDeliveriesRequiringAttentionHoverCardStyles({});
  return (
    <Card elevation={24} className={classes.root} onClick={(event) => event.preventDefault()}>
      {isLoading ? (
        <>
          <TextPlaceholder style={{ marginBottom: '8px' }} />
          <TextPlaceholder lineCount={3} fullWidth />
        </>
      ) : (
        <div className={classes.content}>
          <section className={classes.header}>
            <h1 className={classes.heading}>{heading}</h1>
          </section>
          {title ? <h2 className={classes.title}>{title}</h2> : null}
          {message ? <p className={classes.message}>{message}</p> : null}
          {error ? <p className={classes.message}>{error}</p> : null}
          {events ? (
            <>
              <div className={classes.eventsListWrapper}>
                <ul className={classes.eventsList}>
                  {events.map(({ leftAlignedContent, rightAlignedContent }) => (
                    <li key={leftAlignedContent}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <Box
                          sx={{
                            flexShrink: 0,
                            textAlign: 'left'
                          }}
                        >
                          {leftAlignedContent}
                        </Box>
                        <Box
                          sx={{
                            flexGrow: 1,
                            textAlign: 'right'
                          }}
                        >
                          {rightAlignedContent}
                        </Box>
                      </Box>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          ) : null}
        </div>
      )}
    </Card>
  );
}
